module.exports = __webpack_public_path__ + "static/img/cont63 (2).ea5885c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont63 (2).jpg
// module id = 83UM
// module chunks = 0